import { buildImagekitUrl, ImageResizeOptions } from './imagekit'

export type ImageSize = 180 | 500 | 1080 | 'original'

const IMAGE_RESIZE_DEFAULTS: ImageResizeOptions = {
  quality: 85,
  blur: 0,
  sharpen: 0,
  endpoint: 'default',
  fallback: 'missing.png'
}

export const resizedImageUrl = (imagePath: string | null | undefined, options: ImageResizeOptions = {}) => {
  const optionsWithDefaults = { ...IMAGE_RESIZE_DEFAULTS, ...options }
  return buildImagekitUrl({ path: imagePath, options: optionsWithDefaults })
}

/**
 * @deprecated use resizedImageUrl instead
 */
export function imageUrlFromTemplate(template: string, size: ImageSize): string
export function imageUrlFromTemplate(template: null, size: ImageSize): undefined
export function imageUrlFromTemplate(template: string | null, size: ImageSize) {
  if (template) {
    return template.replace(/\[size\]/g, size.toString()).replace(/\[format\]/g, 'jpg')
  }
}
